import axios from 'axios';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
// import CustomClearIndicator from './MultiSelectBatches';
import Select from 'react-select';
import { BACKEND_SERVER_URL } from '../../../http/http-config';


import FileInput from '../Common-Components/FileInput';
import Input from '../Common-Components/Input';
import { setDropDownStyle } from '../CommonHelper';
import { checkExistingItem } from '../common-helpers/commonServices';
import TinyEditor from '../Common-Components/TinyEditor';
// import './Course.css';



const CUET_SettingModal = forwardRef((props, ref) => {
    const [modalBox, setModalBox] = useState(false);
    const [formData, setFormData] = useState({});
    useImperativeHandle(ref, () => ({
        openModal(data) {
            setFormData(data);
            setModalBox(true);
        }
    }));

    const handleChange = (name, value) => {
        console.log(name, value);
        setFormData((formData) => (
            { ...formData, [name]: value }
        ));
    };

    console.log(formData)
    const handleSubmitCourse = () => {
        axios.post(BACKEND_SERVER_URL + `/cuet/update-settings`, formData).then((response) => {
            setFormData({})
            toast.success(response.data.message)
            props.setDataLoading(!props.loadData)
            setModalBox(false);
        }).catch((error) => {
            toast.error(error.response.data.message)
            console.log(error)
        })

    }


    return (
        <>
            <Modal className="" show={modalBox} onHide={setModalBox} dialogClassName="custom-modal-width" backdrop="static"
                keyboard={false} >
                <Modal.Header>
                    <Modal.Title>Update Setting | {formData.ExamType === "Section-IA" ? "Language Subjects" : formData.ExamType === "Section-II" ? "Domain-Specific Subjects" : formData.ExamType === "Section-III" ? "General Aptitude Test" : formData.ExamType}</Modal.Title>
                    <Button variant="" className="btn-close" onClick={() => setModalBox(false)}></Button>
                </Modal.Header>
                <Modal.Body>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12 d-flex justify-content-around ">
                                <div className="col-5 d-flex">
                                    <Input inputType="number" isMandatory={true} handleChangeCallBack={handleChange} labelName="Question Count" inputValue={formData?.QuestionCount} inputName='QuestionCount' divSizes={[4, 8]} />
                                </div>
                                <div className="col-5 d-flex">
                                    <Input isMandatory={true} inputType="number" handleChangeCallBack={handleChange} labelName="Marks per Question" inputValue={formData?.Marks_per_Question} inputName='Marks_per_Question' divSizes={[4, 8]} />
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-around">
                                <div className="col-5 d-flex">
                                    <Input isMandatory={true} handleChangeCallBack={handleChange} labelName="Negative Marking" inputType="number" inputValue={formData?.Negative_Marking} inputName='Negative_Marking' divSizes={[4, 8]} />
                                </div>
                                <div className="col-5 d-flex">
                                    <Input isMandatory={true} handleChangeCallBack={handleChange} labelName="Duration" inputType="number" inputValue={formData?.Duration} inputName='Duration' divSizes={[4, 8]} />
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-around  ">
                                <div className="col-5 d-flex">
                                    <Input isMandatory={true} handleChangeCallBack={handleChange} labelName="Questions To Be Attempted" inputType="number" inputValue={formData?.QuestionsToBeAttempted} inputName='QuestionsToBeAttempted' divSizes={[4, 8]} />
                                </div>
                                <div className="col-5 d-flex">
                                    <Input isMandatory={true} handleChangeCallBack={handleChange} labelName="Attempts Allowed" inputType="number" inputValue={formData?.Attempt} inputName='Attempt' divSizes={[4, 8]} />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <FileInput isMandatory={true} handleChangeCallBack={handleChange} labelName="Thumbnail" inputType="text" uploadedFileURL={formData?.Thumbnail} inputName='Thumbnail' accept="image/jpeg, image/png, image/gif" />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <TinyEditor handleChangeCallBack={handleChange} labelName="Overview" inputValue={formData?.Description} inputName='Description' />

                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <TinyEditor handleChangeCallBack={handleChange} labelName="Test Instructions" inputValue={formData?.TestInstructions} inputName='TestInstructions' />

                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger light" className='btn-sm' onClick={() => setModalBox(false)}>Close</Button>
                    <Button variant="primary " className='btn-sm ' onClick={handleSubmitCourse}>Update</Button>
                </Modal.Footer>
            </Modal>


        </>
    )
})
export default CUET_SettingModal;